import styled from "styled-components"

export const Header = styled.header`
  text-align: center;
  margin: 1vh 0;
`

export const H1 = styled.h1`
  margin: 0;
`


// WEBPACK FOOTER //
// ./src/components/Title/style.js